"use client";

import React from "react";
import { Plus, Minus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "Que typos de eventos sirven? ",
  answer: "Nos especializamos en auténticos banquetes mexicanos para una gran variedad de celebraciones, incluyendo quinceañeras, bautizos, bodas, fiestas de cumpleaños y grandes reuniones familiares. Llevamos los sabores festivos de México a cualquier ocasión especial."
}, {
  question: "¿Ofrecen servicio completo de catering?",
  answer: "¡Sí! Más allá de nuestra deliciosa comida, nos encargamos a servirles a sus envitados y mantener la comida caliente por las primeras CUATRO HORAS. Nuestro equipo, se asegura de que cada detalle este a su gusto para que puedas disfrutar de la fiesta con tus invitados."
}, {
  question: "¿Se pueden personalizar las ordenes?",
  answer: "¡Por supuesto! Entendemos que cada evento es único. Ya sea que tengas antojo de la birria tradicional, carnitas, mole, o tengas un pedido personal, trabajaremos contigo para crear un menú personalizado que se adapte perfectamente a tu evento."
}, {
  question: "Que areas sirve?",
  answer: "Estamos orgullosos de servir al área metropolitana de Indianápolis y a las comunidades vecinas. Si no está seguro/a de si el lugar de tu evento se encuentra dentro de nuestra área de servicio, por favor contáctanos y con gusto hablaremos sobre los detalles."
}, {
  question: "Como reservo un evento?",
  answer: <span>¡Reservar es muy sencillo! Puedes solicitar una cotización gratuita haciendo clic en el botón Reserva tu Evento en nuestro sitio web o contactándonos directamente al (317) 555-7890. Te recomendamos reservar lo antes posible para asegurar tu fecha preferida.</span>
}];
export default function CelebrationPlanningFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="celebration-planning-faq" ref={ref} className={cn("py-20 bg-background font-sans transition-opacity duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-primary mb-4">Preguntas Comunes </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">Respuestas a tus preguntas más comunes sobre nuestros servicios de auténtico catering Mexicano.</p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-0">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b-0 border-t border-primary/30 data-[state=open]:bg-[#FFFBEB] transition-colors duration-300 px-6">
              <AccordionTrigger className="group hover:no-underline py-6 [&>svg:last-child]:hidden">
                <div className="flex items-center justify-between w-full text-left pr-2">
                  <span className="text-lg font-medium text-foreground group-data-[state=open]:text-primary transition-colors">
                    {faq.question}
                  </span>
                  <span className="relative flex items-center justify-center size-5 shrink-0 ml-4 text-primary/70 group-hover:text-primary transition-colors">
                    <Plus className="absolute size-5 transition-all duration-300 rotate-0 scale-100 opacity-100 group-data-[state=open]:rotate-90 group-data-[state=open]:scale-0 group-data-[state=open]:opacity-0" />
                    <Minus className="absolute size-5 transition-all duration-300 rotate-90 scale-0 opacity-0 group-data-[state=open]:rotate-0 group-data-[state=open]:scale-100 group-data-[state=open]:opacity-100" />
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}